import styled from "styled-components";
import {
  DefaultButton as DefaultBtn
} from "office-ui-fabric-react";

import { Container as MaterialContainer } from "@material-ui/core";

export const Wrapper = styled.div`
  height: calc(100vh - 50px);
  width: calc(100% - 250px);
  overflow: auto;
  flex-basis: 100%;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;

export const ContainerContent = styled.div`
  padding: 20px;
  height: calc(100% - 50px);
`

export const ListContainer = styled.div`
  width: 100%;
  height: calc(100% - 82px);
  overflow-y: auto;
`;

export const DefaultButton = styled(DefaultBtn)`
  width: 110px;
`
export const ContainerDropdownInput = styled.div`
    width: auto;
    display: flex;
    align-items: center;
`

export const InputContainer = styled(MaterialContainer)`
  margin-left: 0px !important;
  padding: 0px !important;
  width: 115px !important;
  margin-right: 0px !important;
`;